export default __webpack_public_path__ + "static/media/MKTGFLO-Logo-RGB-Positive.087082f9.png";